<lib-overlayer
  popUpID="mprd-modem-choice-edit-ont-modal"
  [displaySubTitle]="false"
  [options]="{ backDrop: true, closeViaBackdrop: true }"
  [showModal]="open"
  (onClose)="onClose()"
>
  <ng-container Title>
    {{ "modem-choice.ont-edit-title" | translate }}
  </ng-container>
  <ng-container Content>
    <form
      id="mprd-modem-choice-edit-ont-form"
      [formGroup]="form"
      (ngSubmit)="onEdit()"
    >
      <div
        class="rs-form-item"
        [class.error]="serialNumber.dirty && serialNumber.invalid"
      >
        <input
          type="text"
          id="mprd-modem-choice-edit-ont-serial-number"
          [class.rs-filled]="serialNumber.value"
          formControlName="serialNumber"
          aria-describedby="mprd-modem-choice-edit-ont-serial-number-helper"
        />
        <label for="mprd-modem-choice-edit-ont-serial-number">
          {{ "modem-choice.ont-add-serial-number" | translate }}
        </label>
        <span
          *ngIf="serialNumber.dirty && serialNumber.invalid"
          id="mprd-modem-choice-edit-ont-serial-number-error"
          class="error"
        >
          {{ "modem-choice.ont-add-serial-number-error" | translate }}
        </span>
        <span
          id="mprd-modem-choice-edit-ont-serial-number-helper"
          class="rs-form-helper"
        >
          {{ "modem-choice.ont-add-serial-number-helper" | translate }}
        </span>
      </div>
    </form>
  </ng-container>
  <ng-container Footer>
    <div class="text-right">
      <button
        type="submit"
        class="rs-btn"
        form="mprd-modem-choice-edit-ont-form"
        [disabled]="form.invalid"
        [class.rs-btn-waiting]="pending"
        [attr.role]="pending ? 'alert' : null"
        [attr.aria-live]="pending ? 'polite' : null"
        [attr.aria-busy]="pending"
        [attr.aria-label]="pending ? ('common.loading' | translate) : null"
      >
        {{ "modem-choice.ont-add-save" | translate }}
        <span
          *ngIf="pending"
          class="rs-btn-waiting-dots"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </ng-container>
</lib-overlayer>
